/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {useContext, useEffect, useState} from 'react';
import SystemMessage from "../../models/systemMessageModel";
import SystemMessages from "./systemMessages";
import {AppContext} from "../misc/appContext";
import {saveToLocal} from "../../util/storageUtil";
import {onConnectBolOauth} from "../../util/bolOauthUtil";
import IDate from '@dvrd/idate';
import {SELECTED_ACCOUNT_KEY} from "../../util/constants";

export default function SystemMessagesController() {
    const context = useContext(AppContext);
    const [messages, setMessages] = useState<SystemMessage[]>([]);
    const [apiExpiresInDays, setApiExpiresInDays] = useState<number | null>(null);

    function onDismissMessage(messageId: string) {
        return function () {
            setMessages(messages.filter((message: SystemMessage) => message.id !== messageId));
        }
    }

    function onRenewApi() {
        const {account} = context.accountContext;
        if (!account) return;
        saveToLocal(SELECTED_ACCOUNT_KEY, account.id);
        onConnectBolOauth();
    }

    function setApiExpiry() {
        const {account} = context.accountContext;
        if (!account) return;
        const warnBefore = IDate.now().add(1, 'month');
        for (const apiKey of account.apiKeys) {
            if (!apiKey.useOAuth) continue;
            const expiry = apiKey.refreshExpiresAt;
            if (!expiry) continue;
            if (expiry > warnBefore) continue;
            const diff = expiry.diff(IDate.now(), 'days');
            setApiExpiresInDays(diff);
            return;
        }
        setApiExpiresInDays(null);
    }

    useEffect(() => {
        SystemMessage.getAll((messages: SystemMessage[]) => {
            setMessages(messages);
        })
    }, []);

    useEffect(() => {
        setApiExpiry();
    }, [context.accountContext.account]);

    return (
        <SystemMessages onDismissMessage={onDismissMessage} onRenewApi={onRenewApi} messages={messages}
                        apiExpiresInDays={apiExpiresInDays}/>
    )
}